export const hideFocusVisibility = (target) => {
    target.setAttribute("tabindex", "-1");
    target.setAttribute("aria-hidden", "true");
};
export const showFocusVisibility = (target) => {
    target.setAttribute("tabindex", "0");
    target.setAttribute("aria-hidden", "false");
};
